import { render, staticRenderFns } from "./SliderRow.vue?vue&type=template&id=83d7aa6a&scoped=true"
import script from "./SliderRow.vue?vue&type=script&lang=js"
export * from "./SliderRow.vue?vue&type=script&lang=js"
import style0 from "./SliderRow.vue?vue&type=style&index=0&id=83d7aa6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d7aa6a",
  null
  
)

export default component.exports